import { render, staticRenderFns } from "./bids-list.vue?vue&type=template&id=1a51d9f6&"
import script from "./bids-list.vue?vue&type=script&lang=js&"
export * from "./bids-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports